import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _keyBy from 'lodash/keyBy';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _reduce from 'lodash/reduce';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _head from 'lodash/head';
import { toMoment } from '@tekion/tekion-base/utils/dateUtils';

// Readers
import filterGroupReader, { filterReader } from '../../../readers/FilterGroup';

// helpers
import { mapFilterFromResponse } from '../../../helpers/filterSection.general';

// constants
import FILTER_TYPES from '../../../constants/filterSection.filterTypes';
export var getVisibleDefaultFilters = function getVisibleDefaultFilters(defaultFilterTypes, visibleFilterTypes) {
  return _reduce(defaultFilterTypes, function (acc, filterType) {
    var filterIndex = visibleFilterTypes.findIndex(function (visibleFilter) {
      return visibleFilter.id === filterType;
    });
    if (filterIndex !== -1) {
      acc.push(filterType);
    }
    return acc;
  }, []);
};
export var getFilterGroupMapById = function getFilterGroupMapById(filterGroups) {
  return _keyBy(filterGroups, filterGroupReader.id);
};
export var getFilterGroupIdList = function getFilterGroupIdList(filterGroups) {
  return _map(filterGroups, filterGroupReader.id);
};
export var getSelectedFilters = function getSelectedFilters(filterGroups) {
  var selectedFilterGrp = _find(filterGroups, function (group) {
    return filterGroupReader.selected(group);
  });
  var selectedFilterGroupId = filterGroupReader.id(selectedFilterGrp);
  var filters = _map(filterGroupReader.filters(selectedFilterGrp), mapFilterFromResponse);
  return {
    selectedFilterGroupId: selectedFilterGroupId,
    filters: filters
  };
};

/**
 * API may give filters which aren't mentioned in filterTypes, they must be removed
 */
export var getValidFiltersFromFilterTypes = function getValidFiltersFromFilterTypes(filterTypes, filters) {
  return _filter(filters, function (_ref) {
    var field = _ref.field;
    return _find(filterTypes, function (_ref2) {
      var id = _ref2.id;
      return id === field;
    });
  });
};

/**
 *  normalizes filter value based filter type
 */
var normalizeFilter = function normalizeFilter(filter) {
  if (filterReader.field(filter) === FILTER_TYPES.MONTH_PICKER) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      values: toMoment(_head(filter.values))
    });
  }
  return filter;
};
export var sanitizeFilterGroupList = function sanitizeFilterGroupList(filterGroupList, filterTypes) {
  return _map(filterGroupList, function (filterGroup) {
    var validFilters = getValidFiltersFromFilterTypes(filterTypes, _get(filterGroup, 'filters'));
    var sanitizedFilters = _map(validFilters, normalizeFilter);
    return _objectSpread(_objectSpread({}, filterGroup), {}, {
      filters: sanitizedFilters
    });
  });
};
export var isSelectedFilterGroup = function isSelectedFilterGroup(selectedFilterGroupId) {
  return function (filterGroup) {
    var id = filterGroupReader.id(filterGroup);
    return id === selectedFilterGroupId;
  };
};